// src/utils/rolebasenavigation.ts
"use client";

import { useRouter } from "next/navigation";
import { useRole } from "./RoleContext";

export default function useRoleBasedNavigation() {
  const router = useRouter();
  const { role } = useRole();

  const getRole = () => {
    if (role === "admin") return "admin";
    if (role === "user") return "user";
    if (role === "owner") return "dashboard";
    if (role === "govauth") return "govauth";
    return "";
  };

  const navigate = (path: string) => {
    const fullPath = path.startsWith("/") ? path.slice(1) : path;
    const role = getRole();
    const adminPath =
      role === "admin" ? `/${role}/${fullPath}` : `/${fullPath}`;
    router.push(adminPath);
  };

  return { navigate };
}
